import React from "react";
import '../cssComponents/Loader.css'
const Loader = () => {
    return(
        <>
        <div className="loaderPage">
        <div className="loader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        </div>
        </>
    )
}

export default Loader